<div class="container">
  <div class="row align-items-center">
    <div class="col link-card bg-white">
      <div class="row flex-middle">
        <a class="col-2" data-test="dms-forms-link-card-link">
          <i class="fa-fw fa-wpforms fab fa-3x"></i>
        </a>
        <div class="col-8">
          <a  target="_blank"
            [matTooltip]="'label.dms.OpenPreview' | translate"
            [routerLink]="formPath()?.path"
            [queryParams]="formPath()?.queryParams"
            class="at-file-name text-break"
            data-test="dms-forms-link-card-open-preview-link">
            {{ linkedFormName() }}
            <i class="fas fa-external-link-alt fa-fw"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
